<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Thiết Bị Đo</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-sm-6 col-md-6" v-for="(item, index) in devices" :key="index">
            <div class="small-box" :class="[item.property_type === 1 ? 'bg-orange' : 'bg-aqua']">
              <div class="inner">
                <h3 v-if="item.property_type === 1">Điện</h3>
                <h3 v-else-if="item.property_type === 2">Nước</h3>
                <p>Tên Thiết Bị: {{item.name}}</p>
                <p>Mã: {{item.code}}</p>
                <p>Chỉ Số Hiện Tại: 
                  <b-form-input
                    type="number"
                    class="amount"
                    v-model="item.amount"
                  />
                </p>
              </div>
              <div class="icon">
                <i class="fa fa-bolt" v-if="item.property_type === 1"></i>
                <i class="fa fa-tint" v-else-if="item.property_type === 2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          v-if="apartment_type === 1"
          type="button"
          class="btn btn-labeled btn-default pull-right"
          style="margin-right: 5px;"
          @click="onFinalize"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-forward"></i>
          </span>
          Chốt & Chuyển Qua Căn Hộ Dịch Vụ
        </button>
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onSave"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          Cập Nhật Chỉ Số
        </button>
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
// import utils from '@/lib/utils'

export default {
  name: "MeterDevices",
  data() {
    return {
      id: 0,
      devices: []
    };
  },

  watch: {
    APARTMENT_DETAIL_DATA: function() {
      //
    },
  },
  computed: {
    
    ...mapGetters([
      "GET_SNACK_BAR",
      "APARTMENT_DETAIL_DATA"
    ]),
    apartment_type: function() {
      return this.APARTMENT_DETAIL_DATA.apt_type
    }
  },

  methods: {
    ...mapActions([
      "GET_APARTMENT_METERDEVICES",
      "SET_APARTMENT_METERDEVICES",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "CHANGE_RESIDENT_TO_SERVICE_APARTMENT"
    ]),
    onSave: function() {
      let data = this.devices
      this.SET_APARTMENT_METERDEVICES({id: this.id, data: data})
        .then(
          function(){
            this.SUCCESS_TOAST()
          }.bind(this)
        )
        .catch(
          function(){
            this.ERROR_TOAST()
          }.bind(this)
        )
    },
    onFinalize: function() {
      let data = this.devices
      this.SET_APARTMENT_METERDEVICES({id: this.id, data: data})
        .then(
          function(){
            let apartment_id = this.id;
            let payload = {
              data: [apartment_id],
              apartment_type: "service_apt"
            };
            this.CHANGE_RESIDENT_TO_SERVICE_APARTMENT(payload)
              .then(
                function() {
                  this.SUCCESS_TOAST();
                  this.$router.push({
                    name: "ApartmentList"
                  });
                }.bind(this)
              )
              .catch(
                function(error) {
                  this.ON_SHOW_TOAST({
                    message: error.response.data.message,
                    styleType: "danger"
                  });
                }.bind(this)
              );
          }.bind(this)
        )
        .catch(
          function(){
            this.ERROR_TOAST()
          }.bind(this)
        )
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.GET_APARTMENT_METERDEVICES({ id: this.id }).then(
      function(res){
        let devices = []
        res.forEach(v => {
          let item = {
            id: v.id,
            amount: v.amount ? v.amount : 0,
            code: v.code,
            property_type: v.property_type,
            name: v.name
          }
          devices.push(item)
        })
        this.devices = devices
      }.bind(this)
    )
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>

.amount {
  display: inline;
  width: 50%;
}

</style>



// WEBPACK FOOTER //
// src/views/Apartment/MeterDevices.vue